
//新建tagsView.js
const tagsView = {
  
  state: {
    visitedViews: [
    //   {
    //   path: "/DeviceInfo",
    //   name:"设备信息",
    //   title:"设备信息"
    // }
  ],
      
    cachedViews: [ ]
  },
  mutations: {
    ADD_VISITED_VIEWS: (state, view) => {
      if(state.visitedViews.length==0||view.path=="DeviceInfo"){
        state.visitedViews.push({
            path: "/DeviceInfo",
            name:"设备信息",
            title:"设备信息"
          });
      }if(view.path!="/DeviceInfo"){
        if(view.path!='/login'){
          if (state.visitedViews.some(v => v.path === view.path)) return
            state.visitedViews.push(Object.assign({}, view, {
            title: view.meta.title || 'no-name'
          }))
          if (!view.meta.noCache) {
            state.cachedViews.push(view.name)
          }
        }      
      }
      
    },
    DEL_VISITED_VIEWS: (state, view) => {
      for (const [i, v] of state.visitedViews.entries()) {
        if(v.path!="/DeviceInfo"){
          if (v.path === view.path) {
            state.visitedViews.splice(i, 1)
            break
          }
        }
      }
      for (const i of state.cachedViews) {
        if (i === view.name) {
          const index = state.cachedViews.indexOf(i)
          state.cachedViews.splice(index, 1)
          break
        }
      }
    },
    DEL_OTHERS_VIEWS: (state, view) => {
      for (const [i, v] of state.visitedViews.entries()) {
        debugger
        
          if (v.path === view.path) {
            // state.visitedViews = state.visitedViews.slice(i, i + 1)
            state.visitedViews=[]
            if(view.path=="/DeviceInfo"){
              state.visitedViews.push({
                "name":"设备信息",
                "path":"/DeviceInfo",
                "title":"设备信息"
              })
            }else{
              state.visitedViews.push({
                "name":"设备信息",
                "path":"/DeviceInfo",
                "title":"设备信息"
              },{
                "name":view.name,
                "path":view.path,
                "title":view.title
              })
            }
            
            break
          }
          
        
      }
      for (const i of state.cachedViews) {
        if (i === view.name) {
          const index = state.cachedViews.indexOf(i)
          state.cachedViews = state.cachedViews.slice(index, i + 1)
          break
        }
      }
      
    },
    DEL_ALL_VIEWS: (state) => {
     
      state.visitedViews = [{
        "name":"设备信息",
        "path":"/DeviceInfo",
        "title":"设备信息"
      }]
      state.cachedViews = ["设备信息"]
    }
  },
  actions: {
    addVisitedViews({ commit }, view) {
      commit('ADD_VISITED_VIEWS', view)
    },
    delVisitedViews({ commit, state }, view) {
      
      return new Promise((resolve) => {
        commit('DEL_VISITED_VIEWS', view)
        resolve([...state.visitedViews])
      })
    },
    delOthersViews({ commit, state }, view) {
      return new Promise((resolve) => {
        commit('DEL_OTHERS_VIEWS', view)
        resolve([...state.visitedViews])
      })
    },
    delAllViews({ commit, state }) {
      return new Promise((resolve) => {
        commit('DEL_ALL_VIEWS')
        resolve([...state.visitedViews])
      })
    }
  }
}
 
export default tagsView


// WEBPACK FOOTER //
// ./src/store/tags-view.js